<!-- 专题管理首页 -->
<template>
  <div class="page-module-wrap">
    <div class="tile is-parent">
      <article class="tile is-child box">
        <div class="selectTab">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="专题广告位管理" name="adManagement">
              <p class="buttonStyle fleft">
                <router-link :to="{ name: 'editTopic', query: { topicId: '', operationType: 'add'}}">
                  <span class="button is-success">新增</span>
                </router-link>
              </p>
              <topic-content></topic-content>
            </el-tab-pane>
            <el-tab-pane label="模块设置" name="moduleSetting">
              <module></module>
            </el-tab-pane>
          </el-tabs>
        </div>
      </article>
    </div>
  </div>
</template>

<script type="text/babel">
  import topicContent from './content';
  import module from './module';

  export default {
    components:{
      topicContent, module
    },
    data(){
      return {
        activeName: 'adManagement',
      }
    },
     
    methods: {   
      onAdd() {
        let query = { thirdPartyGoodsId: 12112, operationType: 'add'};
        this.$router.push({
          name: 'editTopic',
          query: query
        });
      },
      onGotoLinkClick(name,link){
        if (!link) {
          return;
        }
        let query = { thirdPartyGoodsId: 12112, operationType: 'add'};
        this.$router.push({
          name: name,
          query: query
        });
      },


    }
  }
</script>

<style rel="stylesheet/less" lang="less" scoped>
  .page-module-wrap{
    .buttonStyle {
      max-width: 50px;
      margin-bottom: 20px;
    }

  } 

</style>